const stripContentURL = (contentURL) => (
  contentURL.replace('/sheets', '')
);

export default stripContentURL;
